import posthog from 'posthog-js';
import { version } from '../package.json';

const POSTHOG_API_KEY = 'phc_WnaJoAxnGmZjYM8B8Xcdd8B7n4qZ7tKVIcbSGPF9Ppm';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

// Kill switch: set to false to permanently disable all PostHog activity
// (no init, no network requests, no event capture) without removing code.
let POSTHOG_ENABLED = false;

const setPosthogEnabled = (enabled) => {
  POSTHOG_ENABLED = enabled;
};

let initialized = false;

function ensureInitialized() {
  if (!POSTHOG_ENABLED) return;
  if (initialized) return;
  initialized = true;

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    enable_heatmaps: false,
    persistence: 'memory',
    before_send: (event) => {
      // Only keep events that were explicitly sent by the SDK (captureError always sets a method tag).
      // This drops noise from PostHog's global error handler (browser extensions, unrelated page errors).
      if (!event.properties?.method) {
        return null;
      }
      return event;
    },
    loaded: (ph) => {
      ph.register({
        sdk_name: 'cs-js-integration',
        sdk_version: version,
      });
    },
  });
}

// Non-actionable errors that don't indicate SDK bugs.
// Network errors: ad blockers, firewalls, privacy settings, or page unload/navigation.
// Third-party library errors: unsupported browsers/environments (e.g., WebViews).
const IGNORED_ERROR_PATTERNS = [
  'Failed to fetch',                    // Chrome/Edge network failure
  'Load failed',                        // Safari network failure
  'NetworkError when attempting to fetch resource', // Firefox network failure
  'cannot determine the browser',       // detectincognitojs (detectIncognito): unsupported browser
  'failed to query storage quota',      // detectincognitojs (detectIncognito): Storage API unavailable (WebViews)
  'queryUsageAndQuota',                 // detectincognitojs (detectIncognito): deprecated Chrome API removed in newer versions
  'Script error',                        // Browser cross-origin restriction masking real errors (already captured by captureError)
  'The operation was aborted.',           // Browser aborted async operation (e.g. fetch cancelled during navigation/unload)
];

function isIgnoredError(error) {
  const message = error?.message || String(error);
  return IGNORED_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

export function captureError(error, tags = {}) {
  try {
    if (!POSTHOG_ENABLED) return;
    if (isIgnoredError(error)) return;

    ensureInitialized();
    if (error instanceof Error) {
      posthog.captureException(error, { ...tags, stack_trace: error.stack });
    } else {
      posthog.captureException(error, tags);
    }
  } catch {
    // Silently fail — never disrupt SDK behavior
  }
}

export function sendTestEvent() {
  try {
    if (!POSTHOG_ENABLED) return;
    ensureInitialized();
    posthog.captureException(
      new Error('[cs-js-integration] PostHog integration test event'),
      { method: 'sendTestEvent', sdk_version: version, test: true }
    );
  } catch {
    // Silently fail
  }
}
